import React from "react";
import { Row, Col } from "antd";
import { useWindowsSize } from "../../libs";
import { Link } from "react-router-dom";
import ErrorPage from "../Notification/Error";

function LoginPage({ props }) {
  const { view, isError, loading, onChange, onView, onSubmit } = props;

  const size = useWindowsSize();
  let width = size.width;

  return (
    <div className="relative">
      <div className="container  w-full relative">
        <Row>
          <Col lg={16} md={16} sm={24} xs={24}>
            <div
              className={`login p-5 md:pt-10 md:px-14 lg:pt-4 lg:px-10 ${
                width > 1366 ? "xl:pt-12" : "xl:pt-6"
              } xl:px-24`}
            >
              <div
                name="icon-header"
                className={
                  width > 1366 ? "flex mb-6 lg:mb-8" : "flex mb-6 lg:mb-6"
                }
              >
                <Link to="/">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "/assets/logo/logo_kemenkes.svg"
                    }
                    alt="kemenkes-logo"
                    className="h-10 w-auto mr-10 lg:h-10 xl:h-12"
                  />
                </Link>
                <Link to="/">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "/assets/logo/logo_blk.svg"
                    }
                    alt="blk-logo"
                    className="h-10 w-auto lg:h-10 xl:h-12 "
                  />
                </Link>
              </div>
              <div
                name="title"
                className={`mb-2 ${width > 1366 ? "lg:mb-8" : "lg:mb-4"}`}
              >
                <p className="header-title-semi login-p text-2xl mb-2 md:text-4xl lg:text-3xl xl:text-5xl xl:mb-5">
                  Hai,{" "}
                  <b className="header-title-bold font-extrabold">
                    Selamat Datanggggggg
                  </b>
                </p>
                <p className="header-title-semi login-p-two font-semibold text-xs md:text-sm lg:text-lg xl:text-xl">
                  Silahkan login untuk melanjutkan
                </p>
              </div>

              <div
                name="container-form"
                className="w-full mt-3 lg:w-8/12 xl:w-6/12"
              >
                {width > 640 ? (
                  <>
                    {/* <button className="btn-google w-full p-2 focus:outline-none lg:p-3">
                      <div className="flex justify-center items-center">
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/ic_google.svg"
                          }
                          alt="icon-google"
                          className="h-auto w-auto lg:h-5 md:h-3 mr-3"
                        />
                        <p className="m-0 font-semibold">Sign in with Google</p>
                      </div>
                    </button>
                    <div
                      name="hr-line"
                      className={`flex ${
                        width > 1366 ? "my-6" : "my-3"
                      } justify-between items-center`}
                    >
                      <span className="login-hr w-2/12 xl:w-1/4"></span>
                      <p className="m-0 login-p-form m-0">
                        or sign in with email
                      </p>
                      <span className="login-hr w-2/12 xl:w-1/4"></span>
                    </div> */}
                  </>
                ) : (
                  <div className="flex justify-end">
                    <img
                      className="h-auto w-10/12"
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/element_login_right.svg"
                      }
                      alt="ic_graphic"
                    />
                  </div>
                )}

                <div name="email-form" className="mb-6 lg:mt-10">
                  <p className="login-title-form mb-3 text-xl lg:text-2xl">
                    Email
                  </p>

                  <input
                    onChange={onChange}
                    disabled={loading}
                    name="email"
                    className={`${
                      loading ? "input-disabled" : "form-input"
                    } outline-none w-full p-3`}
                    placeholder="Masukkan email andazzzzzzz"
                  />
                  {isError
                    ? isError.length > 0
                      ? isError
                          .filter((it) => it.type === "email")
                          .map((its, idx) => (
                            <ErrorPage
                              key={idx}
                              props={{ idx, message: its.message }}
                            />
                          ))
                      : null
                    : null}
                </div>
                <div name="password-form" className="mb-8 lg:mb-6">
                  <div className=" mb-3 flex justify-between items-center">
                    <p className="m-0 login-title-form text-xl lg:text-2xl">
                      Password
                    </p>
                    <Link to={`/account/forgot`}>
                      <p className="header-content m-0 text-right text-blue-500 login-title-forgot lg:text-md">
                        Lupa Password Anda?
                      </p>
                    </Link>
                  </div>
                  <div className="login-input-wrapper">
                    <input
                      onChange={onChange}
                      disabled={loading}
                      name="password"
                      type={view ? "text" : "password"}
                      className={`${
                        loading ? "input-disabled" : "form-input-icon"
                      } outline-none w-full p-3`}
                      placeholder="Masukkan password anda"
                    />
                    <img
                      className="cursor-pointer w-5"
                      onClick={onView}
                      src={
                        process.env.REACT_APP_BASE_URL +
                        `/assets/icon/${view ? "ic_forgot.svg" : "ic_hide.svg"}`
                      }
                      alt="icon-forgot"
                    />
                  </div>
                  {isError
                    ? isError.length > 0
                      ? isError
                          .filter((it) => it.type === "password")
                          .map((its, idx) => (
                            <ErrorPage
                              key={idx}
                              props={{ idx, message: its.message }}
                            />
                          ))
                      : null
                    : null}
                </div>
                <div name="button-save" className="mb-4">
                  <button
                    onClick={onSubmit}
                    disabled={loading}
                    className={`${
                      loading ? "btn-loading" : "btn-blue"
                    } w-full p-3 focus:outline-none lg:mt-5`}
                  >
                    <div className="flex justify-between items-center">
                      <div></div>
                      <p className=" text-white font-semibold lg:text-lg flex items-center">
                        {loading ? "Loading" : "Login"}
                      </p>
                      {!loading ? (
                        <div>
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              "/assets/icon/ic_arrow_right.svg"
                            }
                            alt="icon-arrow"
                          />
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </button>
                </div>
                <div name="info-section" className="">
                  <div
                    className={
                      width > 640
                        ? "flex items-center lg:mt-5"
                        : "flex items-center justify-center lg:mt-5"
                    }
                  >
                    <p className="mr-3 header-content">Belum punya akun ?</p>
                    <Link to="/account/register">
                      <p className="header-content font-semibold text-blue-900">
                        Daftar sekarang
                      </p>
                    </Link>
                  </div>
                </div>
                <div name="copy-section">
                  <div
                    className={
                      width > 640
                        ? "flex items-center mt-2"
                        : "flex items-center mt-2 justify-center"
                    }
                  >
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/ic_copyright.svg"
                      }
                      alt="icon-copyright"
                      className="mr-2 m-0"
                    />
                    <p className=" header-content text-md text-gray-400">
                      SILK. all right reserved
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={8} md={8} sm={0} xs={0}></Col>
        </Row>
      </div>
      {width > 640 && (
        <div
          name="content-right"
          className="login-right absolute top-0 right-0 float-right w-1/3 "
        >
          <div className="login-bg-right relative">
            <div
              style={{
                width: width > 1366 ? "620px" : "550px",
                height: "auto",
              }}
              className="absolute top-16 right-0"
            >
              <img
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/element_login_right.svg"
                }
                className="float-right"
                alt="ic_graphic"
              />
              <div className="flex justify-center ml-10 float-right">
                <div className=" w-2/4">
                  <p className="header-title font-semibold text-white text-2xl">
                    Pemeriksaan Aktual
                  </p>
                  <p className="header-content text-white mt-2">
                    Menjadi laboratorium kesehatan nasional yang berkualitas,
                    unggul, berbudaya dan berteknologi tinggi tahun 2024.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LoginPage;
